import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  discount_price_text: {
    marginRight: 5,
  },
  discount_reminder: {
    alignItems: "center",
    background: palette.secondary.main,
    borderRadius: "20px",
    color: palette.secondary.contrastText,
    display: "flex",
    fontSize: 10,
    justifyContent: "center",
    paddingLeft: 8,
    paddingRight: 8,
  },
  divider: {
    backgroundColor: palette.grey[500],
    height: "1px",
    marginBottom: spacing(2),
    marginTop: spacing(2),
    width: "100%",
  },
  receipt_bottom: {
    backgroundImage: `linear-gradient(320deg, ${palette.primary.light} 15px, transparent 15px), linear-gradient(40deg, ${palette.primary.light} 15px, transparent 15px)`,
    backgroundRepeat: "repeat-x",
    backgroundSize: "20px 20px",
    height: "20px",
    transform: "rotate(180deg)",
  },
  receipt_top: {
    backgroundColor: palette.primary.light,
  },
}));
